import React, { memo, useMemo } from "react";
import cx from "classix";
import { useAuthContext } from "../../context/auth";
import { getLogoByPais } from "../../utils/getLogoByPais";
import "./stylesContainer.scss";

export const Container = memo(({ children, className, header = false, titulo = "titulo" }) => {
  const { pais } = useAuthContext();

  const logo = useMemo(() => getLogoByPais(pais), [pais]);

  return (
    <main className={cx("Container", "container-xl", className)}>
      {header && (
        <header className="header">
          <img src={logo} alt="Logo" className="logo" />
          <h1 className="titulo">{titulo}</h1>
        </header>
      )}
      {children}
    </main>
  );
});
